// Compact US cities dataset. Format: { STATE_CODE: { n: "State Name", c: ["City1", ...] } }
// Source: kelvins/US-Cities-Database (~29,880 US cities/towns).
import raw from "./us_cities.json";

// Flat, memoized list of "City, State" strings — built once on first use.
let _flat = null;
function flat() {
  if (_flat) return _flat;
  const out = [];
  for (const code in raw) {
    const state = raw[code].n;
    for (const city of raw[code].c) {
      out.push({ city, stateCode: code, state, label: `${city}, ${state}` });
    }
  }
  _flat = out;
  return out;
}

/**
 * Fast prefix + substring search across the bundled US city list.
 * - Returns up to `limit` matches (default 8).
 * - Prefix matches on the city name rank first, then in-word matches, then state matches.
 */
export function searchCities(query, limit = 8) {
  const q = (query || "").trim().toLowerCase();
  if (q.length < 2) return [];
  const list = flat();
  const prefix = [];
  const contains = [];
  const stateMatch = [];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    const cityLc = item.city.toLowerCase();
    if (cityLc.startsWith(q)) {
      prefix.push(item);
      if (prefix.length >= limit * 3) break; // hard cap to avoid full scan
    } else if (cityLc.includes(q)) {
      if (contains.length < limit) contains.push(item);
    } else if (item.state.toLowerCase().startsWith(q) || item.stateCode.toLowerCase() === q) {
      if (stateMatch.length < limit) stateMatch.push(item);
    }
  }
  // Prefix matches — sort shorter city names first, then alphabetically
  prefix.sort((a, b) => a.city.length - b.city.length || a.city.localeCompare(b.city));
  const merged = [...prefix, ...contains, ...stateMatch];
  // Deduplicate by label (same city can exist in multiple states — keep both, so dedup by full label)
  const seen = new Set();
  const dedup = [];
  for (const item of merged) {
    if (seen.has(item.label)) continue;
    seen.add(item.label);
    dedup.push(item);
    if (dedup.length >= limit) break;
  }
  return dedup;
}
